module.exports = __webpack_public_path__ + "static/img/10.f62a3405.jpg";